module.exports = __webpack_public_path__ + "img/adhibition-1.7803597.png";